"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.json.stringify.js");
var _react = _interopRequireWildcard(require("react"));
var _dataElement = _interopRequireDefault(require("./dataElement.json"));
var _reactChartjs = require("react-chartjs-2");
require("chartjs-plugin-dragdata");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultgraphData = {
  labels: [],
  datasets: [{
    backgroundColor: [],
    data: [],
    borderWidth: 2
  }]
};
function App(_ref) {
  let {
    dataFromTextArea,
    json,
    graphstyle,
    backdropstyle
  } = _ref;
  console.log("Data from App ", json[0]);
  const Type = json[0].graphtype;
  let Data = [];
  Data = json[0].graphlabels;
  const [_, setJson] = (0, _react.useState)(_dataElement.default);
  const [__, setInputText] = (0, _react.useState)(defaultgraphData);
  const jsonProp = JSON.stringify(json);
  (0, _react.useEffect)(() => {
    if (JSON.stringify(json) == "") {
      if (dataFromTextArea && isJsonString(dataFromTextArea)) {
        setJson(JSON.parse(dataFromTextArea));
      } else if (isJsonString(_dataElement.default)) {
        setInputText(JSON.parse(_dataElement.default));
      }
    } else {
      setJson(JSON.parse(jsonProp));
    }
  }, [dataFromTextArea, json]);
  console.log("Data JSONDataaa ", Data);
  const Labels = Data.map(lan => lan.label);
  const dataVal = Data.map(val => val.value);
  const colorr = Data.map(col => col.color);
  const graphData = {
    labels: Labels,
    datasets: [{
      label: 'Data',
      backgroundColor: colorr,
      data: dataVal
    }]
  };
  const BarOptions = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      yAxes: {
        scaleLabel: {
          display: true
        },
        ticks: {
          beginAtZero: true
        }
      }
    }
  };
  let Dragoptions = {
    onHover: function onHover(e) {
      const point = e.chart.getElementsAtEventForMode(e, 'nearest', {
        intersect: true
      }, false);
      if (point.length) e.native.target.style.cursor = 'grab';else e.native.target.style.cursor = 'default';
    },
    plugins: {
      dragData: {
        round: 1,
        showTooltip: true,
        onDragStart: function onDragStart(e, element) {},
        // Change while dragging 
        onDrag: function onDrag(e, datasetIndex, index, value) {
          e.target.style.cursor = 'grabbing';
        },
        // Only change when finished dragging 
        onDragEnd: function onDragEnd(e, datasetIndex, index, value) {
          e.target.style.cursor = 'default';
          if (datasetIndex == 0) {
            graphData.datasets[index].data = value;
          }
          console.log("Data for post :", graphData.labels[index].label);
        }
      }
    }
  };
  let HorizontalDragoptions = {
    indexAxis: 'y',
    onHover: function onHover(e) {
      const point = e.chart.getElementsAtEventForMode(e, 'nearest', {
        intersect: true
      }, false);
      if (point.length) e.native.target.style.cursor = 'grab';else e.native.target.style.cursor = 'default';
    },
    plugins: {
      dragData: {
        round: 1,
        showTooltip: true,
        onDragStart: function onDragStart(e, element) {},
        // Change while dragging 
        onDrag: function onDrag(e, datasetIndex, index, value) {
          e.target.style.cursor = 'grabbing';
        },
        // Only change when finished dragging 
        onDragEnd: function onDragEnd(e, datasetIndex, index, value) {
          e.target.style.cursor = 'default';
          if (datasetIndex == 0) {
            graphData.datasets[index].data = value;
          }
        }
      }
    }
  };
  const HorizontalOptions = {
    responsive: false,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      yAxes: {
        scaleLabel: {
          display: true
        },
        ticks: {
          beginAtZero: true
        }
      }
    }
  };
  console.log("Data is ", Data);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Type.map(index => {
    let chart;
    if (index.draggablebar === "false" && index.type.toLowerCase() === "horizontal") {
      chart = /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, {
        data: graphData,
        options: HorizontalOptions
      });
    } else if (index.draggablebar === "true" && index.type.toLowerCase() === "vertical") {
      chart = /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, {
        data: graphData,
        options: Dragoptions
      });
    } else if (index.draggablebar === "false" && index.type.toLowerCase() === "vertical") {
      chart = /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, {
        data: graphData,
        options: BarOptions
      });
    } else if (index.draggablebar === "true" && index.type.toLowerCase() === "horizontal") {
      chart = /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, {
        data: graphData,
        options: HorizontalDragoptions
      });
    } else {
      chart = /*#__PURE__*/_react.default.createElement("h1", null, "Please choose corrent Type!");
    }
    return /*#__PURE__*/_react.default.createElement("h1", null, chart);
  }));
}
var _default = exports.default = App;
function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}